export const TERTIARY_BUTTON_CLASS =
    "text-sm md:text-xl font-medium underline tracking-tight hover:text-Primary_Hover active:text-Primary_Pressed not-italic leading-7 font-Montserrat text-Primary_Default text-center";
